import React from "react";
import { PlanCreateForm } from "@components";

const PlanCreate = ({ history }) => {
  return <PlanCreateForm />;
};

export default PlanCreate;
